import * as React from 'react';
import styled from 'styled-components';
import Close from '@material-ui/icons/Close';
import ReportProblem from '@material-ui/icons/ReportProblem';
import { DSGrid, DSLinearProgress, DSPaper, DSTypography } from '../mui';
import { DSIconButton } from '../Generic/Buttons/DSIconButton';
import { HelpPopper } from '../Generic/Poppers/HelpPopper';

const DangerThemedReportProblem = styled(ReportProblem)`
    color: ${({ theme }) => theme.palette.error.main};
`;

const FileUploadContainer = styled(DSPaper)`
    padding: ${({ theme }) => theme.spacing(2)}px;
`;

const Filename = styled(DSTypography)`
    text-overflow: ellipsis;
    overflow: hidden;
`;

const FileSize = styled(DSTypography)`
    color: ${props => props.theme.palette.grey[400]};
`;

export type FileUploadItemProps = {
    filename: string;
    size: number;
    onCancel?: React.MouseEventHandler<HTMLButtonElement>;
    children?: React.ReactNode;
    progress?: number;
    error?: string;
};

export function FileUploadItem({ error, filename, onCancel, progress, size }: FileUploadItemProps): JSX.Element {
    return (
        <FileUploadContainer>
            <DSGrid
                alignItems="center"
                container
                direction="row"
                justifyContent="space-between"
                spacing={2}
                wrap="nowrap"
            >
                <DSGrid container direction="column" item spacing={2} xs zeroMinWidth>
                    <DSGrid
                        alignItems="center"
                        container
                        direction="row"
                        item
                        justifyContent="flex-start"
                        spacing={2}
                        wrap="nowrap"
                    >
                        <DSGrid item xs zeroMinWidth>
                            <Filename nowrap>{filename}</Filename>
                        </DSGrid>
                        <DSGrid item zeroMinWidth>
                            {error && (
                                <HelpPopper
                                    icon={() => <DangerThemedReportProblem />}
                                    placement="top"
                                    popperIcon={() => <></>}
                                >
                                    <DSTypography>{error}</DSTypography>
                                </HelpPopper>
                            )}
                            {!error && <FileSize nowrap>{formatSize(size)}</FileSize>}
                        </DSGrid>
                    </DSGrid>
                    {typeof progress === 'number' && <DSLinearProgress value={progress} variant="determinate" />}
                </DSGrid>
                <DSIconButton zeroMinWidth onClick={onCancel}>
                    <Close />
                </DSIconButton>
            </DSGrid>
        </FileUploadContainer>
    );
}
FileUploadItem.displayName = 'FileUploadItem';

function formatSize(size: number) {
    const GB = 1e9;
    const MB = 1e6;
    const KB = 1e3;

    if (size >= GB) {
        const newSize = (size / GB).toFixed(2);
        return `${newSize}GB`;
    } else if (size >= MB) {
        const newSize = (size / MB).toFixed(2);
        return `${newSize}MB`;
    } else if (size >= KB) {
        const newSize = (size / KB).toFixed(2);
        return `${newSize}KB`;
    } else {
        return `${size}B`;
    }
}
